/**
 * SidebarActions are actions related to the sidebar
 */
import alt from 'components/Dispatcher';

class SidebarActions {
  constructor() {
    this.generateActions('open', 'close');
  }
}

export default alt.createActions(SidebarActions);
